export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11039.cd9a05d6.jpg";